// Styling and layout primitives; callers own labels, accessibility and behaviour.
export const buttonClass = (variant = 'secondary') => 'btn btn-' + variant;
export const actionRow = (secondary, primary, extra = '') => `<footer class="sheet-footer action-row${extra ? ' ' + extra : ''}">${secondary}${primary}</footer>`;
